import { getAreaCategoriesForSeatLayout, getScreenById, getSeatAvailabilityPreviewForShowtime, getSeatLayoutById, getShowtimeById } from '@vista-digital/occ-domain';
export const getSeatingDataForShowtime = (showtimeId) => {
    const showtime = getShowtimeById(showtimeId);
    // Showtime still loading.
    if (!showtime) {
        return;
    }
    if (!showtime.isAllocatedSeating) {
        throw new Error(`Cannot render Showtime Seat Preview for unallocated showtime ${showtimeId}.`);
    }
    const { screenId, seatLayoutId, siteId } = showtime;
    const screen = getScreenById(screenId);
    if (!screen) {
        throw new Error(`Cannot find screen with ID: ${screenId}.`);
    }
    const seatLayout = getSeatLayoutById(seatLayoutId);
    const seatAvailability = getSeatAvailabilityPreviewForShowtime(showtimeId);
    // Data still loading.
    if (!seatLayout || !seatAvailability) {
        return;
    }
    const areaCategories = getAreaCategoriesForSeatLayout(seatLayoutId);
    return {
        areaCategories,
        showtimeAreaCategories: showtime.areaCategories,
        reservedSeatIds: [],
        friendSeatIds: [],
        screen,
        seatAvailabilities: seatAvailability.seatAvailabilities,
        seatLayout,
        seatSelectionLimits: { min: 0, max: 0 },
        siteId
    };
};
//# sourceMappingURL=seating-data-utils.js.map